import { useTranslation } from 'react-i18next';
import {
  useSavedFilterViews,
  type SavedFilterViews,
} from '~/hooks/useSavedFilterViews';
import { preferenceSlot } from '~/hooks/usePreferenceWriteQueue';
import { savedViewMessages } from '~/utils/savedViewMessages';
import type { ProductFilterRow } from './filterClauses';
import {
  FILTER_PERSPECTIVE,
  MY_PRODUCTS_FILTER_VIEWS,
  type MyProductsFilterView,
} from './filterViews';
import {
  myProductsRowsToFilterData,
  readMyProductsFilterRows,
} from './myProductsFilterStorage';

export type MyProductsSavedViews = SavedFilterViews<ProductFilterRow>;

export function useMyProductsSavedViews(
  view: MyProductsFilterView
): MyProductsSavedViews {
  const { t } = useTranslation('my-product');
  const config = MY_PRODUCTS_FILTER_VIEWS[view];
  const toFilterData = (rows: ProductFilterRow[]) =>
    myProductsRowsToFilterData(rows, config.rowsKey);

  return useSavedFilterViews<ProductFilterRow>({
    view,
    perspective: FILTER_PERSPECTIVE,
    slot: preferenceSlot(config.slot, FILTER_PERSPECTIVE),
    isOwnFilterData: config.isOwnFilterData,
    readRows: (filterData) => readMyProductsFilterRows(filterData, config),
    rowsToFilterData: toFilterData,
    activeIdOf: (preferences) => config.activeIdOf(preferences) ?? null,
    anonymousOf: (preferences) => config.anonymousOf(preferences),
    anonymousPreferences: (rows) =>
      config.anonymousKey === 'sellerAnonymousFilter'
        ? { sellerAnonymousFilter: toFilterData(rows) }
        : { sellerPricingAnonymousFilter: toFilterData(rows) },
    messages: savedViewMessages(t, 'filter'),
  });
}
